export default __webpack_public_path__ + "static/media/ic_surveyResultGood.dd4595ab.png";